/**
 * 高级 AI 员工模块的展示用常量。
 *
 * ★这些 id 是后端套餐库（hms 的 src/render/templates/）里的真实 id，
 *   前端只负责把它们翻成人话。加套餐时这里补一行即可 ——
 *   翻不出来的会原样显示 id，不会白屏。
 */
export const STYLE_NAME = {
  authority: '权威科普',
  natural: '清新种草',
  luxury: '高奢极简',
  oriental: '中式国风',
  artisan: '文艺分栏',
}

export const STYLE_DESC = {
  authority: '讲清参数和功能，适合家电数码',
  natural: '明亮清新，适合日常好物',
  luxury: '克制留白，适合美妆香氛',
  oriental: '厚重收藏感，适合文玩茶器',
  artisan: '分栏杂志感，适合手作设计',
}

export const GATE_NAME = {
  style: '风格与页数',
  outline: '文案',
  review: '成品',
}

export const styleName = (id) => STYLE_NAME[id] || id

/**
 * 小红书创作服务平台的发布页。
 * ★没登录会被它自己跳到登录页，这是对方的行为，我们不做判断 ——
 *   与其猜用户登没登，不如直接把他送到门口。
 */
export const XHS_PUBLISH_URL = 'https://creator.xiaohongshu.com/publish/publish'
